<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    var nowTime = new Date().getTime()
    var publishOver = new Date('2020/07/31 23:59:00')
    if (nowTime > publishOver) {
      this.$store.commit('SET_PUBLISHOVER', 1)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue